import Field from "components/common/Field";
import React from "react";

export default function HalfField({ children, ...props }) {
  return (
    <Field width="calc(50% - 8px)" {...props}>
      {children}
    </Field>
  );
}
